import { Box } from '@mui/material'
import CommandNav from './CommandNav'
import CommandRoutes from './CommandRoutes'

const CommandLayout = () => {
  return (
    <>
      <CommandNav />
      <Box sx={{ px: 3 }}>
        <CommandRoutes />
      </Box>
    </>
  )
}

export default CommandLayout
